export default "/images/a883c0d8af827d8bd21c5d433f0bc631.avif";